const defaultReturnPath = '/app/home';

export const authRedirectReturnKey = 'tragenda.authRedirectReturn';

export function safeAuthReturnPath(value?: string | null) {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return defaultReturnPath;
  try {
    const base = new URL('https://tragenda.local');
    const target = new URL(value, base);
    if (target.origin !== base.origin || target.pathname === '/' || target.pathname === '/login') return defaultReturnPath;
    return `${target.pathname}${target.search}${target.hash}`;
  } catch {
    return defaultReturnPath;
  }
}

export function rememberAuthReturnPath(value?: string) {
  sessionStorage.setItem(authRedirectReturnKey, safeAuthReturnPath(value));
}

export function consumeAuthReturnPath() {
  const target = safeAuthReturnPath(sessionStorage.getItem(authRedirectReturnKey));
  sessionStorage.removeItem(authRedirectReturnKey);
  return target;
}

export function clearAuthReturnPath() {
  sessionStorage.removeItem(authRedirectReturnKey);
}

export function shouldUseAuthRedirect(userAgent: string) {
  return /Android|iPhone|iPad|iPod/i.test(userAgent);
}

export function canFallbackFromPopup(error: unknown) {
  const code = (error as { code?: string } | null)?.code;
  return code === 'auth/popup-blocked'
    || code === 'auth/operation-not-supported-in-this-environment'
    || code === 'auth/web-storage-unsupported';
}

const sameOriginAuthDomains = new Set([
  'travel-arc.web.app',
  'travel-arc.firebaseapp.com',
  'auth.tragenda.app',
  'tragenda.app',
  'www.tragenda.app',
  'tragenda.com',
  'www.tragenda.com',
]);

const localDevelopmentHosts = new Set(['localhost', '127.0.0.1', '::1']);

export function authDomainForHost(hostname: string, configuredDomain: string) {
  if (localDevelopmentHosts.has(hostname) && configuredDomain.endsWith('.web.app')) {
    return configuredDomain.replace(/\.web\.app$/, '.firebaseapp.com');
  }
  return sameOriginAuthDomains.has(hostname) ? hostname : configuredDomain;
}
